import Paper from '@material-ui/core/Paper';
import {
  SortingState, GroupingState, SearchState,
  IntegratedFiltering, IntegratedGrouping, IntegratedSorting
} from '@devexpress/dx-react-grid';
import {
  Grid, DragDropProvider,
  VirtualTable, TableHeaderRow, TableGroupRow,
  GroupingPanel, TableColumnReordering, Toolbar, SearchPanel,
} from '@devexpress/dx-react-grid-material-ui';
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import EyeIcon from 'mdi-material-ui/EyeCircle';

const columns = [
  { title: 'Display Name', name: 'displayName' },
  { title: 'User', name: 'userId' },
  { title: 'Actions', name: 'actions' }
];

const missingValue = 'None';

const ShiftTemplatesTable = ({ users, properties, templates, onViewClick }) => {
  const [ formattedData, setFormattedData ] = useState([]);
  const [ columnAlignment ] = useState([
    { columnName: 'actions', align: 'right'},
  ]);
  const [sortingStateColumnExtensions] = useState([
    { columnName: 'actions', sortingEnabled: false }
  ]);
  const [groupingStateColumnExtensions] = useState([
    { columnName: 'actions', groupingEnabled: false }
  ]);

  useEffect(() => {
    setFormattedData(
      Object.values(templates).map(template => ({
        id: template.templateId,
        displayName: template.displayName,
        userId: template.userId ? users[template.userId].displayName : missingValue,
        propertyId: template.propertyId ? properties[template.propertyId].displayName : missingValue,
        actions: (
          <span className={classes.actions}>
            <IconButton onClick={() => onViewClick(template.templateId)}>
              <EyeIcon />
            </IconButton>
          </span>
        )
      })
    )
    )
  }, [templates])

  const classes = useStyles();

  return (
    <>
      <Paper>
        <Grid
          rows={formattedData}
          columns={columns}
          getRowId={row => row.id}
        >
          <DragDropProvider />
          <SearchState />
          <SortingState
            defaultSorting={[
              { columnName: 'displayName', direction: 'asc' }
            ]}
            columnExtensions={sortingStateColumnExtensions}
          />
          <GroupingState
            columnExtensions={groupingStateColumnExtensions}
          />
          <IntegratedFiltering />
          <IntegratedSorting />
          <IntegratedGrouping />
          <VirtualTable
            cellComponent={props => <VirtualTable.Cell {...props} />}
            columnExtensions={columnAlignment}
          />
          <TableHeaderRow showSortingControls />
          <TableColumnReordering defaultOrder={columns.map(column => column.name)} />
          <TableGroupRow />
          <Toolbar />
          <SearchPanel />
          <GroupingPanel showSortingControls />
        </Grid>
      </Paper>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  actions: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  }
}));

const mapStateToProps = state => ({
  users: state.users.byId,
  properties: state.properties.byId,
  templates: state.templates.byId
});

export default connect(mapStateToProps)(ShiftTemplatesTable);
